export const height = {
    desktop: 90,
    mobile: 82,
};
